import { useLocation, Link } from "react-router-dom";
import MinervaMark from "./home/components/MinervaMark";

export default function NotFound() {
  const location = useLocation();

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "32px",
        background:
          "radial-gradient(120% 80% at 50% 0%, rgba(194,162,78,0.06), transparent 55%), var(--ink-900)",
        color: "var(--vellum)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          position: "absolute",
          fontFamily: "var(--font-display)",
          fontSize: "clamp(12rem, 38vw, 26rem)",
          fontWeight: 600,
          color: "var(--gilt)",
          opacity: 0.05,
          lineHeight: 1,
          userSelect: "none",
          pointerEvents: "none",
        }}
      >
        404
      </span>

      <div style={{ position: "relative", zIndex: 1 }}>
        <div style={{ marginBottom: "22px" }}>
          <MinervaMark size={48} strokeWidth={1.2} />
        </div>
        <h1
          style={{
            fontFamily: "var(--font-display)",
            fontOpticalSizing: "auto",
            fontSize: "clamp(1.8rem, 4vw, 2.6rem)",
            fontWeight: 500,
            lineHeight: 1.15,
            marginBottom: "10px",
          }}
        >
          Este folio no existe
        </h1>
        <p
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "0.8rem",
            color: "var(--vellum-faint)",
            letterSpacing: "0.04em",
            marginBottom: "10px",
          }}
        >
          {location.pathname}
        </p>
        <p
          style={{
            fontFamily: "var(--font-read)",
            fontSize: "1.02rem",
            fontStyle: "italic",
            color: "var(--vellum-dim)",
            lineHeight: 1.6,
            maxWidth: "42ch",
            margin: "0 auto 26px",
          }}
        >
          La página que buscas no está en el códice. Vuelve al inicio y retoma el estudio.
        </p>
        <Link
          to="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "var(--gilt)",
            color: "var(--ink-900)",
            fontFamily: "var(--font-ui)",
            fontSize: "0.9rem",
            fontWeight: 600,
            padding: "11px 22px",
            borderRadius: "9px",
            textDecoration: "none",
          }}
        >
          <i className="ri-arrow-left-line" />
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
